import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

import { MenuPlannerTrackingDtoSchema } from '../schemas/MenuPlannerTrackingDto';

// No PathParameters

// No QueryParameters

export const RequestBodySchema = z.array(z.string());
export type RequestBody = z.infer<typeof RequestBodySchema>;

const ResponseDataSchema = z.array(z.lazy(() => MenuPlannerTrackingDtoSchema));
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(input: {
	requestBody: RequestBody;
}): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.BACKEND + '/MenuPlanner/GetTrackingData/tracking';
	return (await axios.post(url, input.requestBody).toOptionalFiltered(validator)).map(
		(x) => x.data
	);
}
